/// <reference path="../../../../../node_modules/@types/googlemaps/index.d.ts" />
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import distance from '@turf/distance';
import { point } from '@turf/helpers';
import { environment } from '../../../../environments/environment';

@Injectable({ providedIn: 'root' })
export class ProjectsService {
  constructor(private http: HttpClient) {}

  getLegend() {
    return this.http.get(`${environment.apiUrl}ouv/legenda`);
  }

  getAddressByCoords({ lat, lng }: { lat: number; lng: number }) {
    return this.http.get(
      `${environment.googleGeoCodeAPI}?latlng=${lat},${lng}&key=${environment.googleMapsKey}`,
      {
        headers: {
          'no-token': '',
        },
      }
    );
  }

  getClosestAddress(addresses: any, latlng: { lat: number; lng: number }) {
    const { lat, lng } = latlng;
    let results = addresses.results as google.maps.GeocoderResult[];
    const streetAddressResults = results.filter((address) =>
      address.types.includes('street_address')
    );

    if (streetAddressResults.length) {
      results = streetAddressResults;
    }

    const targetPoint = point([lat, lng]);

    const distances = results.map((r) => {
      const rLat = +r.geometry.location.lat;
      const rLng = +r.geometry.location.lng;
      const currentPoint = point([rLat, rLng]);
      return distance(targetPoint, currentPoint);
    });

    const indexOfMinValue = distances.reduce(
      (iMin, x, i, arr) => (x < arr[iMin] ? i : iMin),
      0
    );
    const { formatted_address: address } = results[indexOfMinValue];

    return address;
  }
}
